/* tslint:disable */
/* eslint-disable */

/**
 * 0 = Everyone
 *
 * 1 = AdminsOnly
 */
export enum ReleaseNoteAudience {
  Everyone = 0,
  AdminsOnly = 1
}
